import React from 'react';
import { WeezHeader, Tab, Button, Icon } from '@weezevent/nacre';
import TemplateList from './components/templateList';
import DesignList from './components/designList';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { usePermissions } from '../../../user/permissions';
import { SwitchFeature } from '../event/designEvent';

export default function List({ organization, activeTab }) {
    const { t } = useTranslation();
    const history = useHistory();
    const permissions = usePermissions();

    const prefix = React.useMemo(() => {
        return `/ticket/O${organization.id}/tickets_design`;
    }, [organization]);

    const panes = React.useMemo(() => {
        const panesToDisplay = [
            {
                menuItem: t('ticket.ticket_design.designs.label'),
                menuIcon: 'image',
                customProp: '',
                url: 'designs',
                render: () => {}
            }
        ];
        if (permissions.hasCapacities(['PyvarCapacity.DESIGN_ADMIN', 'PyvarCapacity.DESIGN_TEMPLATES'], organization.id))
            panesToDisplay.push({
                menuItem: t('ticket.ticket_design.templates.label'),
                menuIcon: 'edit',
                customProp: '',
                url: 'templates',
                render: () => {}
            });
        return panesToDisplay;
    }, [permissions]);

    const [active, setActive] = React.useState(activeTab);

    React.useEffect(() => {
        setActive(activeTab);
    }, [activeTab]);

    return (
        <>
            <WeezHeader
                title={t('ticket.ticket_design.title')}
                rightComponent={[
                    <Button key={0} onClick={() => history.push(`${prefix}/${active === 0 ? 'designs' : 'templates'}/new`)} primary icon={<Icon name="plus" />}>
                        {t(`ticket.ticket_design.create_${active === 0 ? 'design' : 'template'}.title`)}{' '}
                    </Button>
                ]}
            >
                {t('ticket.ticket_design.description')}
            </WeezHeader>
            <SwitchFeature organization={organization} name={'EO_GABARIT'} />
            <Tab
                panes={panes}
                activeTab={active}
                onTabSelected={(tab, idx) => {
                    setActive(idx);
                    history.push(`${prefix}/${tab.url}`);
                }}
            >
                {active === 0 ? <DesignList organization={organization} /> : <TemplateList organization={organization} />}
            </Tab>
        </>
    );
}
